/** Earnings helpers — platform fee rate follows Admin → Settings. */
import { getPlatformFeeRate } from "./liberFees";

/** Fallback only — live rate comes from getPlatformFeeRate() / admin settings. */
export const LIBER_PLATFORM_FEE_RATE = 0.1;

export function splitEarnings(gross, feeRate) {
  const g = Number(gross);
  const rate =
    Number.isFinite(Number(feeRate)) && Number(feeRate) >= 0 && Number(feeRate) <= 1
      ? Number(feeRate)
      : getPlatformFeeRate();
  if (!Number.isFinite(g) || g < 0) {
    return {
      gross: 0,
      platform_fee: 0,
      net: 0,
      fee_rate: rate,
    };
  }
  const platform_fee = Math.round(g * rate * 100) / 100;
  const net = Math.round((g - platform_fee) * 100) / 100;
  return { gross: g, platform_fee, net, fee_rate: rate };
}

export function formatAed(value) {
  return `AED ${Number(value || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

function rowNetAmount(row) {
  const gross = Number(row?.gross_amount ?? row?.amount ?? 0);
  if (row?.net_amount != null) return Number(row.net_amount);
  return splitEarnings(gross).net;
}

export function sumNetEarningsLast30Days(rows) {
  const cutoff = Date.now() - 30 * 24 * 60 * 60 * 1000;
  return (Array.isArray(rows) ? rows : []).reduce((sum, row) => {
    const t = new Date(row?.updated_at || row?.created_at || 0).getTime();
    if (t >= cutoff) return sum + rowNetAmount(row);
    return sum;
  }, 0);
}

export function buildMonthlyEarningsChart(rows, monthCount = 6) {
  const now = new Date();
  const buckets = [];
  for (let i = monthCount - 1; i >= 0; i--) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const month = d.toLocaleDateString("en-US", { month: "short" });
    const year = String(d.getFullYear()).slice(2);
    buckets.push({
      key: `${d.getFullYear()}-${d.getMonth()}`,
      label: `${month} '${year}`,
      amount: 0,
    });
  }

  (Array.isArray(rows) ? rows : []).forEach((row) => {
    const date = new Date(row?.updated_at || row?.created_at || 0);
    if (Number.isNaN(date.getTime())) return;
    const key = `${date.getFullYear()}-${date.getMonth()}`;
    const bucket = buckets.find((b) => b.key === key);
    if (bucket) bucket.amount += rowNetAmount(row);
  });

  const max = Math.max(...buckets.map((b) => b.amount), 0);
  const scaleMax = max > 0 ? max : 1;
  return buckets.map((b) => ({
    ...b,
    pct: (b.amount / scaleMax) * 100,
    scaleMax,
  }));
}

export function buildEarningsYAxisTicks(maxValue, steps = 10) {
  const scaleMax = Math.max(Number(maxValue) || 0, 1);
  return Array.from({ length: steps + 1 }, (_, i) => {
    const v = (scaleMax * (steps - i)) / steps;
    return v >= 100 ? v.toFixed(0) : v.toFixed(1);
  });
}
